import { defineComponent, h } from 'vue'
import { Icon, type IconName } from '@dacr/ui'

export const MenuList = defineComponent({
  name: 'MenuList',
  setup(_, { slots }) {
    return () =>
      h(
        'div',
        {
          class:
            'w-[280px] py-2.5 bg-white rounded-md [box-shadow:0_0_8px_#0000001a,0_2px_4px_#00000033] z-100',
        },
        slots.default?.()
      )
  },
})

export const MenuListItem = defineComponent({
  name: 'MenuListItem',
  props: {
    icon: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
  },

  setup(props, { slots }) {
    return () =>
      h(
        'div',
        {
          class: [
            'w-full h-8 px-[15px] flex items-center justify-between font-secondary text-[14px] leading-[18px] text-gray-800 tablet-h:hover:bg-[#F6F6F6] cursor-pointer',
            props.disabled && ' pointer-events-none',
          ],
        },
        [
          h(
            'div',
            {
              class: ['flex items-center', props.disabled && ' opacity-40'],
            },
            [
              props.icon &&
                h(Icon, {
                  size: 18,
                  name: props.icon as IconName,
                  class: `${props.icon !== 'Dacr' ? 'stroke-gray-800' : ''} mr-3`,
                }),
              slots.default?.(),
            ]
          ),
          slots.right?.(),
        ]
      )
  },
})

export const MenuListSeparator = defineComponent({
  name: 'MenuListSeparator',
  setup() {
    return () =>
      h('div', {
        class: 'w-full my-2 h-[1px] bg-gray-800/10',
      })
  },
})

export const TallListItem = defineComponent({
  name: 'TallListItem',
  props: {
    icon: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
  },

  setup(props, { slots }) {
    return () =>
      h(
        'div',
        {
          class: [
            'w-full h-[52px] px-[21px] flex items-center justify-between font-secondary text-[16px] leading-[18px] text-gray-800 cursor-pointer',
            props.disabled && ' pointer-events-none',
          ],
        },
        [
          h(
            'div',
            {
              class: ['flex items-center', props.disabled && ' opacity-40'],
            },
            [
              props.icon &&
                h(Icon, {
                  size: 20,
                  name: props.icon as IconName,
                  class: `${props.icon !== 'Dacr' ? 'stroke-gray-800' : ''} mr-5`,
                }),
              slots.default?.(),
            ]
          ),
          slots.right?.(),
        ]
      )
  },
})

export const LargeSeparator = defineComponent({
  name: 'LargeSeparator',
  setup() {
    return () =>
      h('div', {
        class: 'w-full my-[12.5px] min-h-[1px] max-h-[1px] bg-gray-800/10',
      })
  },
})
